import { useEffect, useState } from "react";
import { Accordion, Button, Card, Col, Container, Form, Row, Table } from "react-bootstrap";
import { downloadMembers, getMembers } from "../../controllers/user";
import { useAuth } from "../../components/auth/AuthProvider";
import { Link } from "react-router-dom";
import { getEtapas, getOrg } from "../../controllers/org";
import { getRoles } from "../../controllers/roles";
import Loading from "../../components/loading/Loading";
import { renderRoles } from "../../controllers/utils";
import CrearRegion from "../../components/admin/CrearRegion";
import CrearDiocesis from "../../components/admin/CrearDiocesis";
import CrearComunidad from "../../components/admin/CrearComunidad";

function Org() {
  const [page, setPage] = useState(0);
  const [org, setOrg] = useState();
  const [filteredOrg, setFilteredOrg] = useState();
  const [region, setRegion] = useState();
  const [diocesis, setDiocesis] = useState();
  const [comunidades, setComunidades] = useState();
  const [diocFilterRegion, setDiocFilterRegion] = useState();
  const [filteredDiocesis, setFilteredDiocesis] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const { token, onLogout } = useAuth();

  useEffect(() => {
    loadOrg();
  }, []);
  useEffect(() => {
    if (!region) {
      setDiocesis();
    }
  }, [region]);

  async function loadOrg(){
    let o = await getOrg();
    o.maps = {
      regiones: {},
      diocesis: {},
      comunidades: {}
    };
    o.regiones.forEach((r, i) => {
      o.maps.regiones[r.region_id] = i;
    });
    o.diocesis.forEach((d, i) => {
      o.maps.diocesis[d.diocesis_id] = i;
    });
    o.comunidades.forEach((c, i) => {
      o.maps.comunidades[c.comunidad_id] = i;
      c.diocesisLabel = o.diocesis[o.maps.diocesis[c.diocesis_id]].label;
      c.region_id = o.diocesis[o.maps.diocesis[c.diocesis_id]].region_id;
      c.regionLabel = o.regiones[o.maps.regiones[c.region_id]].label;
    });
    setOrg(o);
    setComunidades(o.comunidades);
    setFilteredDiocesis(o.diocesis);
  }

  async function download() {
    if (isDownloading) {
      return;
    }
    try {
      setIsDownloading(true);
      // const d = await downloadOrg(token, {
      //   region,
      //   diocesis,
      //   comunidad
      // });
      setIsDownloading(false);
    }
    catch (e) {
      setIsDownloading(false);
      if (e.status === 401 || e.status === 403) {
        onLogout();
      }
    }
  }

  function renderComunidades() {
    return comunidades.map((c, i) => <tr key={`comunidad-${c.comunidad_id}`}>
      <td><Link to={`/app/org/regiones/${c.region_id}`}>{c.regionLabel}</Link></td>
      <td><Link to={`/app/org/diocesis/${c.diocesis_id}`}>{c.diocesisLabel}</Link></td>
      <td><Link to={`/app/org/comunidades/${c.comunidad_id}`}>{c.label}</Link></td>
      <td>Editar | Borrar</td>
    </tr>);
  }

  function renderRegiones() {
    return org.regiones.map((r, i) => <tr key={`region-${r.region_id}`}>
      <td><Link to={`/app/org/regiones/${r.region_id}`}>{r.label}</Link></td>
      <td>Editar | Borrar</td>
    </tr>);
  }

  function renderDiocesis() {
    return filteredDiocesis.map((d, i) => <tr key={`diocesis-${d.diocesis_id}`}>
      <td><Link to={`/app/org/regiones/${d.region_id}`}>{org.regiones[org.maps.regiones[d.region_id]].label}</Link></td>
      <td><Link to={`/app/org/diocesis/${d.diocesis_id}`}>{d.label}</Link></td>
      <td>Editar | Borrar</td>
    </tr>);
  }

  function renderDiocesisOptions() {
    if (!region) {
      return [
        <option value={null} key={`filter-diocesis-null`}>-- Selecciona una región --</option>
      ]
    }
    let d = org.diocesis.filter(d => d.region_id === region);
    d.unshift({ value: null, label: '-- Selecciona una diócesis -- '});
    return d.map(d => <option value={d.diocesis_id} key={`filter-diocesis-${d.diocesis_id}`}>{d.label}</option> );
  }

  function renderComunidadOptions() {
    if (!region) {
      return [
        <option value={null} key={`filter-comunidad-null-1`}>-- Selecciona una región --</option>
      ];
    }
    if (!diocesis) {
      return [
        <option value={null} key={`filter-comunidad-null-2`}>-- Selecciona una diócesis --</option>
      ];
    }
    let c = org.comunidades.filter(c => c.diocesis_id === diocesis);
    c.unshift({ value: null, label: '-- Selecciona una comunidad -- '});
    return c.map(c => <option value={c.comunidad_id} key={`filter-comunidad-${c.comunidad_id}`}>{c.label}</option> );
  }

  function onSubmit(e) {
    e.preventDefault();
    let c = org.comunidades.filter(c => {
      if (!region) {
        return true;
      }
      else if (!diocesis) {
        return c.region_id === region;
      }
      else {
        return c.region_id === region && c.diocesis_id == diocesis;
      }
    });
    
    setComunidades(c);
  }

  function filterDiocesis(e) {
    e.preventDefault();
    let d = org.diocesis.filter(d => {
      if (!diocFilterRegion) {
        return true;
      }
      else {
        return d.region_id === diocFilterRegion;
      }
    });
    
    setFilteredDiocesis(d);
  }

  if (!org || isLoading) {
    return <Loading text="Cargando"></Loading>
  }

  return <Container>
    <h1 className="pt-5">Organización</h1>
    <Row className="mt-5">
      <Col md={6}>
        <Row>
          <Col>
            <h2>Regiones</h2>
            <Table striped hover className="mt-1">
              <thead>
                <tr>
                  <td>Región</td>
                  <td>Acciones</td>
                </tr>
              </thead>
              <tbody>
                {renderRegiones()}
              </tbody>
            </Table>
          </Col>
        </Row>
        <Row className="mt-5">
          <Col>
            <h2>Diócesis</h2>
            <Accordion>
              <Accordion.Item eventKey="0">
                <Accordion.Header>Filtros</Accordion.Header>
                <Accordion.Body>
                  <Form onSubmit={filterDiocesis}>
                    <Row>
                      <Col md={3}>
                        <Form.Group className="mb-3">
                          <Form.Label>Región</Form.Label>
                          <Form.Select name='region' onChange={e => setDiocFilterRegion(parseInt(e.target.value))}>
                            <option value={null}>-- Selecciona una región --</option>
                            { org.regiones.map(r => <option value={r.region_id} key={`diocesis-filter-region-${r.region_id}`}>{r.label}</option>) }
                          </Form.Select>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={3}>
                        <Button type="submit" variant="primary">Filtrar</Button>
                      </Col>
                    </Row>
                  </Form>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>

            <Table striped hover className="mt-1">
              <thead>
                <tr>
                  <td>Región</td>
                  <td>Diócesis</td>
                  <td>Acciones</td>
                </tr>
              </thead>
              <tbody>
                {renderDiocesis()}
              </tbody>
            </Table>
          </Col>
        </Row>
        <Row className="mt-5">
          <Col>
          <h2>Comunidades</h2>
            <Accordion>
              <Accordion.Item eventKey="0">
                <Accordion.Header>Filtros</Accordion.Header>
                <Accordion.Body>
                  <Form onSubmit={onSubmit}>
                    <Row>
                      <Col md={3}>
                        <Form.Group className="mb-3">
                          <Form.Label>Región</Form.Label>
                          <Form.Select name='region' onChange={e => setRegion(parseInt(e.target.value))}>
                            <option value={null}>-- Selecciona una región --</option>
                            { org.regiones.map(r => <option value={r.region_id} key={`filter-region-${r.region_id}`}>{r.label}</option>) }
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group className="mb-3">
                          <Form.Label>Diócesis</Form.Label>
                          <Form.Select name='diocesis' onChange={e => setDiocesis(parseInt(e.target.value))}>
                            { renderDiocesisOptions() }
                          </Form.Select>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={3}>
                        <Button type="submit" variant="primary">Filtrar</Button>
                      </Col>
                    </Row>
                  </Form>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>

            <Row>
              <Col className="mt-3" style={{textAlign: 'right'}}>
                <Button onClick={download}>{isDownloading ? 'Descargando...' : 'Descargar'}</Button>
              </Col>
            </Row>

            <Table striped hover className="mt-5">
              <thead>
                <tr>
                  <td>Región</td>
                  <td>Diócesis</td>
                  <td>Comunidad</td>
                  <td>Acciones</td>
                </tr>
              </thead>
              <tbody>
                {renderComunidades()}
              </tbody>
            </Table>
          </Col>
        </Row>
      </Col>
      <Col md={6}>
        <Row>
          <Container>
            <CrearRegion token={token} onSuccess={loadOrg} />
          </Container>
        </Row>
        <Row className="mt-5">
          <Container>
            <CrearDiocesis org={org} onSuccess={loadOrg} />
          </Container>
        </Row>
        <Row className="mt-5">
          <Container>
            <CrearComunidad org={org} onSuccess={loadOrg} />
          </Container>
        </Row>
      </Col>
    </Row>
  </Container>;
}

export default Org;